"use client";

import Image from "next/image";
import Button from "@/components/Button/Button";
import { Container } from "react-bootstrap";
import ctaImage from "@/assets/images/products/serviceconnect/cta-image.png";
import "./CTASection.scss";
import Link from "next/link";

const CTASection = () => {
  return (
    <section className="cta-section" id="contact">
      <Container>
        <div className="section-content">
          <h2>Ready to Transform Your Service Operations?</h2>
          <p>
            Join hundreds of service-driven businesses using Service Connect to
            streamline workflows, boost productivity, and deliver top-notch
            customer experiences.
          </p>

          <Link href="/contact">
            <Button variant="primary" size="lg" className="get-started-btn">
              Get Started
            </Button>
          </Link>
        </div>

        <div className="image-section">
          <Image
            src={ctaImage}
            alt="CTA Image"
            className="img-fluid"
            width={500}
            height={400}
          />
        </div>
      </Container>
    </section>
  );
};

export default CTASection;
